import "./Cumpleaños.css";
import React, { useState, useEffect, useRef } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import CargandoSpinner from "../../0. Utilidades/loadingSpinner"; // Import the spinner component
import PersonAvatar from "../../0. Utilidades/PersonAvatar";
import { getApiUrl } from "../../../utils/apiUrl";

function CumpleIcon() {
  const [cumples, setCumples] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const [showTooltip, setShowTooltip] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    const apiUrl = getApiUrl("api/personas/cumpleanos-proximos/");
    fetch(apiUrl, { credentials: "include" })
      .then((response) => response.json())
      .then((data) => {
        setCumples(data);
        setLoading(false); // Set loading to false once data is fetched
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        setLoading(false); // Stop loading in case of an error
      });
  }, []);

  const handleMouseEnter = (index) => {
    clearTimeout(timerRef.current);
    setShowTooltip(index);
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setShowTooltip(null);
    }, 500); // Adjust delay to desired hover time
  };

  const handleTooltipMouseEnter = () => {
    clearTimeout(timerRef.current);
  };

  const handleTooltipMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setShowTooltip(null);
    }, 500); // Adjust delay to desired hover time
  };

  return (
    <div id="cumpleaños">
      <h3>Próximo Cumpleaños</h3>
      {loading ? (
        <CargandoSpinner /> // Show spinner while loading
      ) : (
        <div className="prox-cumpleaños">
          {cumples.map((icon, index) => (
            <OverlayTrigger
              key={index}
              placement="top"
              show={showTooltip === index}
              overlay={
                <Tooltip
                  id={`tooltip-${index}`}
                  className="custom-tooltip"
                  onMouseEnter={handleTooltipMouseEnter}
                  onMouseLeave={handleTooltipMouseLeave}
                >
                  <strong>{icon.nombre}</strong>
                  <br />
                  {icon.nacimiento_formatted}
                  <br />
                  <a href={`/maestras/${icon.id}`}>Ver perfil</a>
                </Tooltip>
              }
            >
              <div
                className={`prox-cumpleaños-icon ${icon.color ? `${icon.color}-glow` : ""}`}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              >
                <PersonAvatar
                  src={icon.imagen}
                  name={icon.nombre}
                  alt={`Fotografía de ${icon.nombre}`}
                  className="birthday-person-avatar"
                  tone="maestra"
                />
              </div>
            </OverlayTrigger>
          ))}
        </div>
      )}
    </div>
  );
}

export default CumpleIcon;
